import {
    Deferred,
    Flash,
    Instance,
    Script,
    Service,
} from '@siposdani87/sui-js';
import { app } from '../app';
import { ConfigService } from './configService';

export class GoogleIdentityService extends Service {
    static readonly inject = ['instances', 'configService'];

    script: Script;
    flash: Flash;

    constructor(
        instances: Instance,
        private configService: ConfigService,
    ) {
        super();

        this.script = instances.script;
        this.flash = instances.flash;
    }

    private _asyncInit(): void {
        // No init method
    }

    loadSDK(): void {
        this.script
            .load('google-3P', 'https://accounts.google.com/gsi/client')
            .then(() => {
                this._asyncInit();
            });
    }

    reset(): void {
        this.script.remove('google-3P');
    }

    loginDialog() {
        const deferred = new Deferred<string, undefined>();

        (window as any)['google']['accounts']['id']['initialize']({
            client_id: this.configService.get<string>('google.client_id'),
            use_fedcm_for_prompt: true,
            callback: (response: any) => {
                const idToken = response['credential'];
                deferred.resolve(idToken);
            },
        });
        (window as any)['google']['accounts']['id']['prompt'](
            (notification: any) => {
                if (notification['isDismissedMoment']?.()) {
                    deferred.reject();
                } else if (notification['isSkippedMoment']?.()) {
                    deferred.reject();
                }
            },
        );

        return deferred.promise();
    }
}

export const googleIdentityService = app.service('googleIdentityService', GoogleIdentityService);
